import { Link } from "react-router-dom";
import BrandMark from "./BrandMark";
import { useHostThemePreview } from "../lib/hostThemePreview";

const WORDMARK = {
  /** Marketing / night hero — soft cream wordmark via wordmarkClassName */
  sticker: "font-display font-semibold text-[18px] tracking-tight",
  /** In-app quiet wordmark */
  readable: "font-ui font-semibold text-[17px] tracking-tight",
  quiet: "font-ui font-semibold text-[17px] tracking-tight",
};

export default function BrandLink({
  to = "/",
  variant = "quiet",
  size,
  testId,
  className = "",
  wordmarkClassName = "",
  children = "rsvp.dance",
  "aria-label": ariaLabel,
  /** When true, icon click cycles host theme (Home / feed). Wordmark still navigates. */
  cycleTheme = false,
}) {
  const resolved = variant === "readable" ? "quiet" : variant;
  const markSize = size ?? (resolved === "sticker" ? "sm" : "md");
  const { themeId, cycleTheme: doCycle, canCycle } = useHostThemePreview();
  const enableCycle = cycleTheme && canCycle;

  const mark = <BrandMark size={markSize} themeId={enableCycle ? themeId : undefined} />;

  if (enableCycle) {
    return (
      <div
        className={`flex items-center gap-2 min-w-0 ${className}`}
        data-testid={testId}
      >
        <button
          type="button"
          onClick={() => doCycle()}
          className="shrink-0 rounded-btn focus-visible:outline focus-visible:outline-2 focus-visible:outline-orchid/45 focus-visible:outline-offset-2"
          aria-label="Cycle page theme"
          data-testid="brand-theme-cycle"
        >
          {mark}
        </button>
        <Link
          to={to}
          className="min-w-0 truncate rounded-btn focus-visible:outline focus-visible:outline-2 focus-visible:outline-orchid/45 focus-visible:outline-offset-2"
          aria-label={ariaLabel}
        >
          <span className={`${WORDMARK[resolved] || WORDMARK.quiet} ${wordmarkClassName}`}>
            {children}
          </span>
        </Link>
      </div>
    );
  }

  return (
    <Link
      to={to}
      className={`flex items-center gap-2 min-w-0 rounded-btn focus-visible:outline focus-visible:outline-2 focus-visible:outline-orchid/45 focus-visible:outline-offset-2 ${className}`}
      data-testid={testId}
      aria-label={ariaLabel}
    >
      {mark}
      <span className={`truncate ${WORDMARK[resolved] || WORDMARK.quiet} ${wordmarkClassName}`}>{children}</span>
    </Link>
  );
}
